module.exports = __webpack_public_path__ + "static/krawat-06825fb09511324aae347d5ea1493794.png";